module.exports = __webpack_public_path__ + "img/sv90.80be0cc6.svg";